module.exports = "<div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\" #heading>{{ element.name }}</div>\r\n    <div class=\"panel-body\">\r\n        <!-- directive - to mark a place for the content. The content is placed in server-console-2 -->\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/server-console-2/server-element/server-element.component.html
// module id = ./src/app/components/server-console-2/server-element/server-element.component.html
// module chunks = main